import {Card, MatchScorers, Team, TimelineUpdateType, TimelineVideo} from 'utils/types';
import {TimelineStateData} from 'store/timelineUpdateCmds/types';
import {useCallback, useState} from 'react';

type VideosFromTimeLineFn = {
  loading: boolean;
  data: TimelineStateData;
  error?: string | boolean;
};

/**
 * Static helper function
 */
const _getVideosFromTimeline = (timelineState: VideosFromTimeLineFn) => {
  const {data} = timelineState;
  const videos: TimelineVideo[] = [];

  data.updates.forEach(({type, content, comment, relatedVideo}) => {
    if (type === TimelineUpdateType.VIDEO_HIGHLIGHT && content && relatedVideo === true) {
      if (typeof content === 'object' && 'embed' in content && content.embed) {
        videos.push({embed: content.embed, title: comment ?? ''});
      }
    }
  });

  return videos;
};

/**
 * Return type of the useTimelineVideos hook
 */
type useTimelineVideosResult = [
  TimelineVideo[],
  {getVideosFromTimeline: (timelineState: VideosFromTimeLineFn) => void}
];

/**
 * Provides list of current match scorers (derived by timeline updates: goal, etc)
 * @param matchId MongoDB match Id (provided by URL)
 */
const useTimelineVideos = (): useTimelineVideosResult => {
  const [videos, setVideos] = useState<TimelineVideo[]>([]);

  const getVideosFromTimeline = useCallback(
    (timelineState: VideosFromTimeLineFn) => {
      const {loading, error} = timelineState;
      if (!loading && !error) setVideos(_getVideosFromTimeline(timelineState));
    },
    [setVideos]
  );

  return [videos, {getVideosFromTimeline}];
};

export default useTimelineVideos;
